module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.27fc0bcf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/theme/fonts/Gotham-Bold.eot
// module id = 877
// module chunks = 40